import { createFileRoute } from "@tanstack/react-router"
import { SpinShow } from "@/features/live-events-admin/screen/SpinShow"

export const Route = createFileRoute("/tv/$screenKey")({
	component: TvPage,
	staticData: { publicPage: true },
})

/** The spin show's public, read-only TV link: open it on the booth TV, no sign-in needed. */
function TvPage() {
	const { screenKey } = Route.useParams()
	return <SpinShow screenKey={screenKey} />
}
